var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',{class:['fn-ui-report-row', {'fn-ui-report-row-total': _vm.isTotal}, {'fn-ui-report-row-controls': _vm.hasControls}],style:(_vm.cssVars)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }